<template>
  <div class="card shadow-sm rounded-5 text-center" :class="color">
    <div class="row align-items-center">
      <div class="col-6 text-start d-flex align-items-center">
        <div class="m-3 d-none d-md-block">
          <GroupIcon :index="index" width="100px" :title="name" />
        </div>
        <span class="fs-3 fw-bold my-auto">{{ name }}</span>
      </div>
      <div class="col position-relative">
        <div class="d-flex justify-content-center position-relative">
          <StarIcon :points="points" :color="color" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarIcon from "@/components/activity/StarIcon.vue";
import GroupIcon from "@/components/activity/GroupIcon.vue";

// Data
export default {
  name: "GroupCardv2",
  components: { GroupIcon, StarIcon },
  props: {
    index: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    points: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    isTopGroup: {
      type: Boolean,
      default: false
    }
  }
};
</script>
